import { render } from "./ActivityHistory.vue?vue&type=template&id=224a41fc&scoped=true"
import script from "./ActivityHistory.vue?vue&type=script&lang=js"
export * from "./ActivityHistory.vue?vue&type=script&lang=js"

import "./ActivityHistory.vue?vue&type=style&index=0&id=224a41fc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-224a41fc"

export default script